



import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import OrderList from './OrderList.vue';
@Component({
  components: { AdminIframe, OrderList },
})
export default class OrderListIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/fulfillment/order/order-integration' + '?' + queryString;
    
    this.remoteSrc = src;
  }

  created() {
    this.setRemoteSrc();
  }
}
